module.exports = __webpack_public_path__ + "static/media/ic_operator_play.2b9ce521.svg";